/** This file is auto generated by convertSvgToJsx.ts */

import type { IconSVGProps } from '../../components/icon/Icon'
const compose = (props?: IconSVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m13.93 4.05.66-.66a1.4 1.4 0 1 0-1.98-1.98l-.66.66m1.98 1.98L8.65 9.33l-2.31.33.33-2.31 5.28-5.28m1.98 1.98-1.98-1.98M6 3.8H1.933A.933.933 0 0 0 1 4.735v9.333a.934.934 0 0 0 .933.934h9.334a.933.933 0 0 0 .933-.934V10"
    />
  </svg>
)
export default compose
